<template>
  <div class="object-info__actions">
    <div class="object-info__actions-wrapper">
      <div v-for="action in filteredActions" :key="action.title">
        <el-button
          class="r-button"
          size="mini"
          @click="callFunction(action.title)"
          :type="action.type"
          :icon="action.icon"
        >
          {{ $t(action.title) }}
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
const actions = [
  { title: "flyTo", icon: "el-icon-search", type: "primary" },
  { title: "delete", icon: "el-icon-delete", type: "danger" }
];

export default {
  props: {
    id: {
      type: String,
      default: ""
    },
    sourcename: {
      type: String,
      default: ""
    },
    hasDeletePermission: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      actions
    };
  },
  computed: {
    defaultPath() {
      return this.$store.state.defaultPath.split("/").pop();
    },
    filteredActions() {
      return this.actions.filter(e => {
        if (e.title === "delete") return this.hasDeletePermission;
        else return true;
      });
    }
  },
  methods: {
    callFunction(title) {
      switch (title) {
        case "delete":
          this.beforeDeleteObject();
          break;
        case "flyTo":
          this.beforeFlyTo();
          break;
      }
    },
    beforeDeleteObject() {
      const warningText = `${this.$t("modal.warning_text::delete")}`;
      const warningTitle = `${this.$t("modal.warning_title")}`;
      const confirmButtonText = `${this.$t("modal.confirm_button")}`;
      const cancelButtonText = `${this.$t("modal.cancel_button")}`;

      this.$confirm(warningText, warningTitle, {
        customClass: "r-message-box",
        type: "warning",
        closeOnClickModal: false,
        confirmButtonText,
        cancelButtonText
      })
        .then(() => {
          this.$emit("delete");
          return;
        })
        .catch(() => {});
    },
    beforeFlyTo() {
      if (this.defaultPath !== "map") {
        this.$store.commit("NEED_TO_CALL_CARD", {
          id: this.id,
          sourcename: this.sourcename
        });
        this.setDefaultPath("map");
        this.$router.push({ path: "/app/map" });
      } else {
        this.flyTo();
      }
    },
    setDefaultPath(value) {
      this.$store.commit("SET_DEFAULT_PATH", value);
    },
    async flyTo() {
      try {
        const config = JSON.stringify({
          only: ["id", "geom"],
          where: { field: "id", value: this.id, op: "=" }
        });
        const { data } = await this.$store.dispatch("REQUEST", {
          url: `objectInfo/${this.sourcename}?config=${config}`
        });
        const { geom } = data[this.id];
        this.$store.commit("SET_FLY_TO_GEOM", geom);
      } catch (error) {
        console.log(error);
      }
    },
    observe() {
      // observer mode (on map)
      if (!this.isObserveModeEnabled)
        this.$store.commit("SET_FUNCTIONS_STATE_PROP", {
          fn: "observe",
          value: true,
          id: this.id,
          layer: this.sourcename
        });
      else
        this.$store.commit("SET_FUNCTIONS_STATE_PROP", {
          fn: "observe",
          value: false,
          id: "",
          layer: ""
        });
    },
    enableGeomEditor() {
      // enable geom editor (on map)
      const layer = this.$store.state.map.activeLayers.find(
        item => item.id === this.sourcename
      );
      if (!layer.isEditorActive) {
        if (!layer.isActive) return;
        // this.moveTo();
        const layers = this.$store.state.map.activeLayers;
        layers.forEach(item => {
          if (item.isEditorActive) item.isEditorActive = false;
        });
        layer.isEditorActive = true;
        this.$store.commit("SET_EDITOR_ONLYONE_ID", this.id);
        this.$store.commit("SET_EDITING_LAYER", layer.id);
        this.$store.commit(
          "SET_GEOM_TYPE",
          layer.datatype ? layer.datatype : layer.geom_type
        );
        this.$store.commit("TOGGLE_EDITOR", true);
        this.$store.commit("SET_EDITOR_MODEL_MODE", !!layer.datatype);
        this.$store.commit("SET_EDITOR_MODE", "editing");
      } else {
        layer.isEditorActive = false;
        this.$store.commit("TOGGLE_EDITOR", false);
        this.$store.commit("SET_EDITOR_ONLYONE_ID", "");
      }
    },
    openDiagram() {
      let options = {
        // x: 500,
        // y: 500,
        // height: 550,
        title: "Chart",
        sourcename: this.sourcename,
        id: this.id
      };
      this.$store.commit("ADD_NEW_OVERHEAD_WINDOW", options);
    }
  }
};
</script>

<style lang="scss"></style>

<i18n>
{
  "ru": {
    "delete": "Удалить объект",
    "flyTo": "Найти на карте",
    "observe": "Режим наблюдения",
    "editgeom": "Редактор геометрии",
    "diagram": "Графики",

    "modal.confirm_button": "Да",
    "modal.cancel_button": "Нет",
    "modal.warning_title": "Предупреждение",
    "modal.warning_text::delete": "Объект будет удалён без возможности восстановления. Продолжить?"
  },
  "en": {
    "delete": "Delete object",
    "flyTo": "Find on map",
    "observe": "Observe mode",
    "editgeom": "Edit geometry",
    "diagram": "Charts",

    "modal.confirm_button": "Yes",
    "modal.cancel_button": "No",
    "modal.warning_title": "Warning",
    "modal.warning_text::delete": "The object will be permanently deleted. Continue?"
  }
}
</i18n>
